import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const USER_PIPELINES_SERVICE_CONFIG_TOKEN = new InjectionToken<UserPipelinesServiceConfig>(
  'general dependency data for the user pipelines',
);
export interface UserPipelinesServiceConfig {
  partnerId$: Observable<string>;
}

export const PARTNER_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken('token for current partner id');
